import { styled } from '@mui/material/styles';
import {
  TableCell,
  TableContainer,
  TablePagination,
  tablePaginationClasses as classes,
} from '@mui/material';
import { COLOR, TRANSPARENT_COLOR } from '@src/styles/color';
import { MOBILE_BREAKPOINT } from '@src/styles/config';

const CustomTablePagination = styled(TablePagination)(
  () => `
    & .${classes.spacer} {
      display: none;
    }
  
    & .${classes.toolbar}  {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;
      padding-left: 19px;
    }
    svg {
        font-size: 24px; 
        fill: rgba(30, 22, 78, 1);
        cursor: pointer;
      }
    & .${classes.selectLabel} {
      margin: 0;
      color: rgba(60, 60, 67, 0.64);
      font-family: "SF Pro", sans-serif;
    }
    & .${classes.select}{
      border-radius: 8px; 
      width: 100%;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      font-family: "SF Pro", sans-serif;
      background-color: transparent;
      color: #3C3C43A3;
      transition: all 100ms ease;

    &:focus {
     border-radius: 8px; 
     border-radius: 8px; 
       background-color: transparent;
    }
      
    }
  
    & .${classes.displayedRows} {
      margin: 0;
      color: rgba(60, 60, 67, 0.64);
      font-family: "SF Pro", sans-serif;
      @media (min-width: 768px) {
        margin-left: auto;
      }
    }
    `,
);
const StyledLoadingTable = styled('div')`
  display: flex;
  justify-content: center;
  align-items: center;
  height: ${(props) => (props?.tableHeight ? props?.tableHeight : '326px')};
  .loading-load-request {
    color: ${COLOR.loadingLoadRequest};
  }
`;

const StyledTableCell = styled(TableCell)`
  .header-cell {
    background-color: ${COLOR.indigo[4]};
    color: ${COLOR.dark};
    padding: 6px 12px;
    width: ${(props) => (props.width ? props.width : 'auto')};
  }
  .header-title {
    font-weight: bold;
    font-size: 14px;
  }
  .header-checkbox-cell {
    background-color: ${COLOR.primary};
    color: ${COLOR.white};
    padding: 4px 6px;
    width: 2%;
  }
  .body-cell {
    border-bottom: 1px solid ${COLOR.divider};
    padding: 0px 12px;
    width: ${(props) => (props.cellWidth ? props.cellWidth : 'auto')};
  }
  .checkbox-cell {
    border-bottom: 1px solid ${COLOR.divider};
    padding: 0px 8px;
    width: ${(props) => (props.cellWidth ? props.cellWidth : 'auto')};
    width: 2%;
  }
  .hidden {
    display: none !important;
  }
`;

const StyledTableScrollbar = styled('div')`
  width: 100%;
  .sidebar-wrapper {
    overflow: auto;
    flex: 1;
    position: relative;
    color: inherit;
    @media screen and (max-width: 600px) {
      padding-bottom: ${(props) => (props.detailsApp ? '0px' : '88px')};
    }
  }

  .hidden-scrollbar {
    &::-webkit-scrollbar {
      width: 4px;
      background: ${COLOR.white};
    }
    &::-webkit-scrollbar-thumb {
      width: 4px;
      background: ${COLOR.white};
    }
    &::-webkit-scrollbar {
      width: 4px;
      background: ${COLOR.white};
    }
  }

  .small-scrollbar {
    // scrollbar-width: thin;
    &::-webkit-scrollbar {
      width: 4px;
      height: 4px;
    }
    &::-webkit-scrollbar-track {
      background: ${COLOR.white};
    }
    &::-webkit-scrollbar-thumb {
      background: ${COLOR.indigo[64]};
      border-radius: 100px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: ${COLOR.indigo[80]};
      border-radius: 100px;
    }
  }
`;
const StyledNewPagination = styled(TableContainer)`
  width: 100%;
  overflow: hidden;
  position: relative;
  padding: ${(props) => props.styleFooter?.padding || '0px'};
  height: ${(props) => props.styleFooter?.height || '47px'};
  box-sizing: border-box;
  .MuiSvgIcon-root {
    width: 32px;
  }
  .prevBtn {
    padding: 8px;
    border-radius: 8px;
    display: flex;
    justify-content: center;
    cursor: pointer;
    align-items: center;
    opacity: ${(props) => props.isDisabledPrev && 0.3};
    border: 1px solid #3c3c4329;
    box-shadow: none;
  }
  .nextBtn {
    padding: 8px;
    border-radius: 8px;
    display: flex;
    opacity: ${(props) => props.isDisabledNext && 0.3};
    cursor: pointer;
    justify-content: center;
    box-shadow: none;
    align-items: center;
    border: 1px solid #3c3c4329;
  }
`;
const StyledTable = styled(TableContainer)`
  overflow: auto;
  height: ${(props) => props.height};

  max-height: ${(props) =>
    props.heightTableProjects ? props.heightTableProjects : '280px'};
  min-height: 'max-content';
  max-width: 100%;
  background: ${COLOR.white};

  .loading-infinite {
    align-items: center;
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: center;
    position: fixed;
    width: 90%;
    .loading__dot {
      animation: dot ease-in-out 1s infinite;
      background-color: grey;
      display: inline-block;
      height: 8px;
      border-radius: 50%;
      margin: 10px 2px;
      width: 8px;
    }

    .loading__dot:nth-of-type(2) {
      animation-delay: 0.2s;
    }

    .loading__dot:nth-of-type(3) {
      animation-delay: 0.3s;
    }

    @keyframes dot {
      0% {
        background-color: ${COLOR.darkBlue};
        transform: scale(1);
      }
      50% {
        background-color: #fff;
        transform: scale(1.3);
      }
      100% {
        background-color: ${COLOR.darkBlue};
        transform: scale(1);
      }
    }
  }

  .rc-virtual-list-scrollbar-thumb {
    background: ${COLOR.indigo[64]}!important;
    width: 8px !important;
    transition: all;
    &:hover {
      background: ${COLOR.indigo[80]}!important;
    }
  }

  .header-cell {
    background-color: ${(props) =>
      props.stickyHeader ? '#f6f6f8' : COLOR.indigo[4]};
    color: ${COLOR.dark};
    padding: ${(props) =>
      props.headerPadding ? props.headerPadding : '6px 12px'};
    z-index: 10;
  }

  .header-checkbox-cell {
    background-color: ${(props) =>
      props.stickyHeader ? '#f6f6f8' : COLOR.indigo[4]};
    color: ${COLOR.white};
    padding: 4px 6px;
    width: 2%;
  }

  .header-item {
    display: flex;
    align-items: center;
    & .MuiIconButton-root {
      padding-right: 0px;
      padding-left: 0px;
      margin-left: 8px;
      margin-right: -8px;
    }
  }

  .header-left {
    justify-content: left;
  }

  .header-right {
    justify-content: right;
  }

  .header-center {
    justify-content: center;
  }

  .header-title {
    font-weight: bold;
    font-size: 14px;
  }

  .header-icon,
  .header-checkbox {
    color: ${COLOR.darkBlue} !important;
  }

  .body-checkbox {
    color: ${COLOR.darkBlue} !important;
    margin-left: -1.3px;
  }
  .body-row-cursor {
    cursor: pointer;
  }
  .body-row {
    @keyframes example {
      from {
        background-color: white;
      }
      to {
        background-color: #ffd60a29;
      }
    }

    &:first-child {
      animation-name: ${(props) => props.isFlickerBg && 'example'};
      animation-duration: 1s;
      animation-fill-mode: forwards;
      animation-iteration-count: infinite;
    }
    &:last-child td,
    &:last-child th {
      border: 0;
    }
    &:hover {
      background: ${TRANSPARENT_COLOR.dark};
      position: relative;

      .hover-visible {
        display: flex;
        position: absolute;
        right: 0px;
        z-index: 1;
        bottom: 1; // Fix action buttons not appearing on the same line when hovering a table row in Safari. I don't know why it is not work with bottom: 0.
        border: 0;
        background: linear-gradient(
            ${TRANSPARENT_COLOR.dark},
            ${TRANSPARENT_COLOR.dark}
          ),
          linear-gradient(white, white);
      }
    }

    .hover-visible {
      display: none;
    }
    /* cursor: pointer; */
  }

  .body-cell {
    box-sizing: border-box;
    border-bottom: 1px solid ${COLOR.divider};
    padding: ${(props) => (props.detailsApp ? '5.5px 4px' : '5.5px 12px')};
    width: ${(props) => props.cellWidth && props.cellWidth};
  }

  .checkbox-cell {
    border-bottom: 1px solid ${COLOR.divider};
    padding: 6px 8px;
    width: ${(props) => (props.cellWidth ? props.cellWidth : 'auto')};
    width: 2%;
  }
`;

export const StyledFooterNoData = styled('div')`
  height: 21px;
`;

export const StyledFooterLoading = styled('div')`
  height: 46px;
`;

export const StyledNodataLoading = styled('div')`
  height: ${(props) => props.height || 'auto'};
  width: 100%;
  display: flex;
  justify-content: left;
  align-items: top;
`;

export const StyledTableFooter = styled('div')`
  display: flex;
  height: 47px;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: ${({ footerpadding }) => footerpadding || '20px'};

  .Mui-selected {
    color: ${COLOR.darkBlue} !important;
  }

  .one-line {
    display: flex;
    justify-content: center;
    margin-top: 1px;
  }

  .pagination {
    margin-right: 0px;
  }

  .button-select-amount-page {
    width: 10px;
    height: 20px;
    border: 1px solid gray;
    margin-left: 5px;
    display: flex;
    justify-content: flex-end;
    padding-right: 5px;
  }

  .footer-label {
    font-weight: 600;
    padding-top: 10px;
    margin-left: 20px;
  }

  @media only screen and (min-width: ${MOBILE_BREAKPOINT}) {
    flex-direction: row;

    .footer-label {
      font-size: 12px;
    }
  }

  @media only screen and (max-width: ${MOBILE_BREAKPOINT}) {
    flex-direction: column;

    .footer-label {
      font-size: 14px;
      margin-bottom: 10px;
    }
  }
`;

export {
  StyledTableCell,
  CustomTablePagination,
  StyledTable,
  StyledNewPagination,
  StyledTableScrollbar,
  StyledLoadingTable,
};
